import { ReactNode } from "react";

import { Stack } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

const changeFormatter = new Intl.NumberFormat("en-US", {
  signDisplay: "exceptZero",
  maximumFractionDigits: 1,
});

export interface WeightWithChangeDisplayProps {
  weightDisplay: ReactNode;
  change: number | undefined;
}

export function WeightWithChangeDisplay({ weightDisplay, change }: WeightWithChangeDisplayProps) {
  return (
    <Stack gap={0}>
      {weightDisplay}
      {change !== undefined && (
        <TextWrapper c={change > 0 ? "green.7" : "red.7"}>
          {changeFormatter.format(change)}
        </TextWrapper>
      )}
    </Stack>
  );
}
